import {useRef, useEffect} from "react"
import {useSelector} from "react-redux"
import {REALM_HEADER} from "@next/utils"
import State from "../../models/state"
import {onPageLoadGtmTrigger} from "../../utils/onPageLoadGtmTrigger"
import {doGoogleAnalytics} from "../../utils/featureSwitch"
import removeCurrencyAndSpaces from "../../utils/removeCurrencyAndSpaces"
import {getSearchKeyword} from "../../utils/getPLPDefaultTitle"
import isMadeToMeasure from "../../utils/isMadeToMeasure"
import {generateMinMaxPrice} from "../../utils/generateMinMaxPrice"

const selectStateForGTM = (state: State) => {
    if (!state.productSummary) return null

    const {colourways, currencyCode, department, title, brand} = state.productSummary.summaryData
    const client = state.request.headers[REALM_HEADER] as string
    if (!colourways || colourways.length <= 0) return null
    const firstProduct = colourways[0]
    const useSalePrice = !!firstProduct.sp
    let finalPrice

    const selectedColourway = colourways.find(colourway => colourway.s)

    if (isMadeToMeasure(selectedColourway?.pt)) {
        finalPrice = selectedColourway?.mp
    } else if (useSalePrice) {
        finalPrice = firstProduct.sp || ""
    } else {
        finalPrice = firstProduct.p
    }

    finalPrice = removeCurrencyAndSpaces(finalPrice)
    return {
        productId: firstProduct.id,
        productTitle: firstProduct.t ?? `${firstProduct?.c} ${title}`,
        ...generateMinMaxPrice(finalPrice),
        colour: firstProduct?.c,
        currencyCode,
        department,
        searchKeyword: department,
        brand,
        client,
    }
}

const useGTMSelectorProps = () => {
    // To enforce running only once
    const state = useSelector(selectStateForGTM, () => true)
    return state
}

export const useGTMOnHydrate = () => {
    const isMounted = useRef(false)
    const state = useGTMSelectorProps()

    useEffect(() => {
        if (!doGoogleAnalytics()) return
        if (isMounted.current || !state) return
        const {href, search} = window.location
        state.searchKeyword = getSearchKeyword(href, search) || state.searchKeyword
        onPageLoadGtmTrigger(state)
        isMounted.current = true
    }, [state])
}

export default useGTMOnHydrate
